import React from 'react'

import ReactMarkdown from 'react-markdown'

import MarkdownLink from './MarkdownLink'

interface MarkdownProps {
  children: string
}

export function MarkdownRenderer({ children }: MarkdownProps) {
  return (
    <ReactMarkdown
      components={{
        a: MarkdownLink,
      }}
    >
      {children}
    </ReactMarkdown>
  )
}
